var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',_vm._l((_vm.conferencistas),function(t,index){return _c('v-card',{key:index,staticClass:"mb-8"},[_c('v-img',{attrs:{"src":t.img,"eager":true}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }